import React, { Component } from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import GridItem from '../components/grid-item'
import './home.sass'
import ArrowIcon from '../components/svgs/arrow-right'
import { FormattedMessage } from 'react-intl'

export default class IndexPage extends Component {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event('scroll'))
    }
  }

  render() {
    const allImages = this.props.data.allImageSharp.edges
    const news = this.props.data.datoCmsNewsInHomepage

    const imageMap = {
      interviste: allImages.find(
        image => image.node.sizes.src.indexOf('interviste_base') >= 0
      ),
      intervisteHover: allImages.find(
        image => image.node.sizes.src.indexOf('interviste_hover') >= 0
      ),
      mappe: allImages.find(
        image => image.node.sizes.src.indexOf('mappe_base') >= 0
      ),
      mappeHover: allImages.find(
        image => image.node.sizes.src.indexOf('mappe_hover') >= 0
      ),
      eventi: allImages.find(
        image => image.node.sizes.src.indexOf('eventi_base') >= 0
      ),
      eventiHover: allImages.find(
        image => image.node.sizes.src.indexOf('eventi_hover') >= 0
      ),
      'relazioni-e-conferenze': allImages.find(
        image => image.node.sizes.src.indexOf('conferenze_base') >= 0
      ),
      'relazioni-e-conferenzeHover': allImages.find(
        image => image.node.sizes.src.indexOf('conferenze_hover') >= 0
      ),
      pubblicazioni: allImages.find(
        image => image.node.sizes.src.indexOf('pubblicazioni_base') >= 0
      ),
      pubblicazioniHover: allImages.find(
        image => image.node.sizes.src.indexOf('pubblicazioni_hover') >= 0
      ),
      progetto: allImages.find(
        image => image.node.sizes.src.indexOf('progetto_base') >= 0
      ),
      progettoHover: allImages.find(
        image => image.node.sizes.src.indexOf('progetto_hover') >= 0
      ),
    }

    const { data } = this.props

    let locale = 'it'

    if (typeof window !== 'undefined') {
      locale = window.localStorage.getItem('locale')
    }

    const linkPrefix = locale === 'it' ? '' : '/en'

    return (
      <div>
        <div className="pb-4">
          <Helmet>
            <title>{data.site.siteMetadata.title}</title>
          </Helmet>

          {news.mostra && (
            <div className="Home__News wrap-home">
              <Link
                to={`${linkPrefix}${news.paginaCollegata.fields.path}`}
                className="News"
                dangerouslySetInnerHTML={{ __html: news.testo }}
              />
              <Link to={`${linkPrefix}${news.paginaCollegata.fields.path}`}>
                <ArrowIcon className="Home__ArrowIcon" />
              </Link>
            </div>
          )}

          <div className="LinksGrid LinksGrid--2rows wrap-home px-1 mt-2">
            <GridItem link="progetto" imageMap={imageMap} />
            <GridItem link="mappe" imageMap={imageMap} />
            <GridItem link="eventi" imageMap={imageMap} />
            <GridItem link="interviste" imageMap={imageMap} />
            <GridItem link="relazioni-e-conferenze" imageMap={imageMap} />
            <GridItem link="pubblicazioni" imageMap={imageMap} />
          </div>
        </div>
        <div className="Home__Smallprint text-bold">
          <div className="wrap-narrower">
            <FormattedMessage id="home.smallprint" />
          </div>
        </div>
      </div>
    )
  }
}

export const query = graphql`
  query Homepage($locale: String!) {
    site {
      siteMetadata {
        title
      }
    }
    datoCmsNewsInHomepage(locale: { eq: $locale }) {
      mostra
      paginaCollegata {
        fields {
          path
        }
      }
      testo
    }
    allImageSharp {
      edges {
        node {
          sizes {
            base64
            aspectRatio
            src
            srcSet
            sizes
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js